import React, { Suspense, useEffect, useState } from "react";
import {
  AppBar,
  Box,
  IconButton,
  LinearProgress,
  Link,
  Stack,
  SvgIcon,
  Toolbar,
  Tooltip,
  useTheme,
} from "@mui/material";
import { Outlet, useLocation, useParams } from "react-router-dom";
import ModifySubscription from "./dashboard/ModifySubscription";
import { Close, Logout, Menu } from "@mui/icons-material";
import Sidebar from "./Sidebar";

function App() {
  const theme = useTheme();
  const location = useLocation();
  const { organization } = useParams();
  const [sidebarVisible, setSidebarVisible] = useState(false);

  // Automatically close sidebar (if open) on navigation
  useEffect(() => {
    setSidebarVisible(false);
  }, [location.pathname]);

  return (
    <>
      {/* Header */}
      <AppBar component="header" position="fixed">
        <Toolbar
          sx={{ height: { xs: theme.spacing(6), sm: theme.spacing(8) } }}
        >
          <Stack
            direction="row"
            width="100%"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack direction="row" alignItems="center" gap={2}>
              <Link underline="none" href="/" color="inherit">
                <Logo />
              </Link>
              <Link
                underline="none"
                variant="h6"
                href="/"
                color="inherit"
                sx={{ display: { xs: "none", sm: "block" } }}
              >
                Cirrus Runners
              </Link>
            </Stack>
            <Stack direction="row" alignItems="center" gap={2}>
              <ModifySubscription />
              <Tooltip title="Sign out">
                <IconButton
                  component={Link}
                  href="/logout"
                  size="large"
                  color="inherit"
                >
                  <Logout />
                </IconButton>
              </Tooltip>
              {organization && (
                <IconButton
                  size="large"
                  color="inherit"
                  sx={{ display: { sm: "none" } }}
                  onClick={() => {
                    setSidebarVisible(!sidebarVisible);
                  }}
                >
                  {sidebarVisible ? <Close /> : <Menu />}
                </IconButton>
              )}
            </Stack>
          </Stack>
        </Toolbar>
      </AppBar>

      {/* Sidebar */}
      <Sidebar organization={organization} sidebarVisible={sidebarVisible} />

      {/* Content */}
      <Box
        sx={{
          paddingTop: theme.spacing(8),
          paddingLeft: {
            sm: organization ? theme.spacing(32) : 0,
          },
        }}
      >
        <Box
          padding={3}
          sx={{
            display: sidebarVisible ? "none" : "block",
          }}
        >
          <Suspense fallback={<LinearProgress />}>
            <Outlet />
          </Suspense>
        </Box>
      </Box>
    </>
  );
}

function Logo() {
  return (
    <SvgIcon>
      <svg
        width="192px"
        height="192px"
        viewBox="0 0 146 141"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs></defs>
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
        >
          <g
            id="cirrus-logo"
            transform="translate(7.000000, 7.000000)"
            stroke="#FAFAFA"
            strokeWidth="13.5"
          >
            <path
              d="M0,126.494118 L111,126.494118"
              id="Shape"
              fill="#000000"
              fillRule="nonzero"
            ></path>
            <path
              d="M111,126.494118 C122.59798,126.494118 132,117.055227 132,105.411765 C132,93.7683027 122.59798,84.3294118 111,84.3294118"
              id="Shape"
            ></path>
            <path
              d="M0,84.3294118 L111,84.3294118"
              id="Shape"
              fill="#000000"
              fillRule="nonzero"
            ></path>
            <path
              d="M111,84.3294118 C122.59798,84.3294118 132,74.8905208 132,63.2470588 C132,51.6035968 122.59798,42.1647059 111,42.1647059"
              id="Shape"
            ></path>
            <path
              d="M0,42.1647059 L111,42.1647059"
              id="Shape"
              fill="#000000"
              fillRule="nonzero"
            ></path>
            <path
              d="M111,42.1647059 C122.59798,42.1647057 132,32.7258148 132,21.0823529 C132,9.43889104 122.59798,1.73501101e-07 111,-3.55271368e-15"
              id="Shape"
            ></path>
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
}

export default App;
